import axios from "axios";

/**
 * apiCallerExt — caller for the non-PBS bonusing backends (promotions engine,
 * loyalty). Unlike apiCaller it does NOT send the UPS Authorisation/MerchantId
 * pair, does not run the refresh-token retry, and lets each call supply its
 * own auth headers. Both the promotions and loyalty services share the same
 * HTTP Basic auth credentials stored in REACT_APP_LOYALTY_BASIC_AUTH.
 *
 * URLs are pre-built by the caller (EndpointConfig convention); `params` is
 * only serialized as the JSON body for POST/PUT/DELETE.
 */
export function apiCallerExt(url, method, params, extraHeaders = {}) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Basic ${process.env.REACT_APP_LOYALTY_BASIC_AUTH || ""}`,
    ...extraHeaders,
  };

  const requestConfig = { headers, method };
  if (params && (method === "POST" || method === "PUT" || method === "DELETE")) {
    requestConfig.data = JSON.stringify(params);
  }

  return new Promise((resolve, reject) => {
    axios
      .request(url, requestConfig)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject({
          response:
            error?.response?.data?.message ||
            error?.response?.data?.msg ||
            error?.message,
          statusCode: error?.response?.status,
          statusText: error?.response?.statusText,
          data: error?.response?.data,
        });
      });
  });
}

/** Convenience wrapper for the loyalty GraphQL endpoint. */
export function graphqlCaller(url, query, variables, extraHeaders = {}) {
  return apiCallerExt(url, "POST", { query, variables }, extraHeaders).then(
    (res) => {
      if (res && Array.isArray(res.errors) && res.errors.length) {
        return Promise.reject({
          response: res.errors[0]?.message || "GraphQL error",
          data: res,
        });
      }
      return res && res.data !== undefined ? res.data : res;
    }
  );
}
